<div class="dialog-default p-4">
  <h1 mat-dialog-title>Mise à jour</h1>
  <p>Une nouvelle version du site est disponible, la page va être rechargée!</p>
  <div class="d-flex flex-row justify-content-end">
    <button (click)="dismiss()" class="btn btn-primary my-2 mx-2" type="button">Recharger</button>
  </div>
</div>
